import { render, staticRenderFns } from "./PortletCard.vue?vue&type=template&id=7fcb8981&scoped=true&shadow"
import script from "./PortletCard.vue?vue&type=script&lang=js&shadow"
export * from "./PortletCard.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./PortletCard.vue?vue&type=style&index=0&id=7fcb8981&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7fcb8981",
  null
  ,true
)

export default component.exports